// Implementation request endpoint — Packet W2a.
import { api } from "../api";

export const submitImplementationRequest = async (payload) =>
  (await api.post("/implementation/request", payload)).data;
